module.exports = __webpack_public_path__ + "static/media/software-maintenance.21eeb538.jpg";